import React,{useEffect,useState} from 'react';
import DataTable from '../../../components_shared/DataTable';
import api, { apiBaseUrl } from '../../../utils/api';
export default function FinalReceiptsPage(){
 const[rows,setRows]=useState([]);const[loading,setLoading]=useState(true);const[err,setErr]=useState(null);
 useEffect(()=>{(async()=>{
  try{
   const res=await api.get('/api/v1/inventory/dispatch-notes',{params:{status:'RECEIVED_FINAL',page:0,size:50,sort:'id,desc'}});
   setRows(res.data.content||[]);
  }catch(e){setErr(e.message);}finally{setLoading(false);} })();},[]);
 const cols=[
  {accessorKey:'referenceNo',header:'Ref #'},
  {accessorKey:'workOrderNo',header:'Work Order'},
  {accessorKey:'quantity',header:'Qty'},
  {accessorKey:'createdAt',header:'Received At',cell:({row})=> new Date(row.original.createdAt).toLocaleString()},
  {id:'pdf',header:'PDF',cell:({row})=> (
    <button className="btn btn-primary btn-sm" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/final-receipts/${row.original.id}/pdf`,'_blank')}>📄 Final Receipt</button>
  )}
 ];
 if(loading) return <p>Loading...</p>; if(err) return <div className='alert alert-danger'>{err}</div>;
 return <div className="inventory-page"><div className="premium-card inventory-page-card"><h2>Completed Receipts</h2><DataTable data={rows} columns={cols}/></div></div>;
}
